export const SAMPLE_NOTES = [
  {
    id: "mvc-femur",
    title: "MVC – Right femur fracture",
    text: `Trauma activation. 34-year-old male, unrestrained driver in a high-speed MVC on Interstate 80, approximately 1 hour prior to arrival. Airbag deployed. Pt extricated by EMS.

Exam: GCS 15. Obvious deformity of right thigh with shortening and external rotation. Right femoral pulse diminished. No open wounds. Small laceration on forehead, 3 cm, sutured. Tender right 5th-7th ribs with crepitus. Abdomen soft.

Imaging: CT pan-scan — displaced mid-shaft fracture of right femur. Non-displaced fractures of right 5th, 6th, 7th ribs without pneumothorax. Small right pulmonary contusion.

Procedure (OR same day): Open reduction and internal fixation of right femoral shaft fracture with intramedullary nail, open approach. Estimated blood loss 300 mL.

Mechanism: Motor vehicle collision, driver. Place: interstate highway. Activity: driving.`,
  },
  {
    id: "fall-hip",
    title: "Ground-level fall – Left hip",
    text: `78-year-old female presents to ED after a ground-level fall at home in the bathroom while walking to the toilet. Slipped on a wet tile floor. No LOC. Complains of severe left hip pain, unable to bear weight.

Exam: Left lower extremity shortened and externally rotated. No skin breakdown.

X-ray: Displaced intracapsular fracture of the left femoral neck.

Plan: Admitted for left hemiarthroplasty. Procedure performed next morning: replacement of left femoral head with prosthesis, open approach.

Mechanism: Fall on same level from slipping. Place of occurrence: bathroom of single-family home. Initial encounter.`,
  },
  {
    id: "assault-head",
    title: "Assault – Closed head injury",
    text: `22-year-old male brought in by EMS after assault outside a nightclub. Punched in the face and struck on the head with a glass bottle. Brief LOC per witnesses, approximately 1-2 minutes.

Exam: 4 cm laceration to the left parietal scalp, closed with staples. Right periorbital ecchymosis. GCS 14 on arrival, improved to 15. Nasal bone tenderness.

Imaging: CT head — small left frontal subarachnoid hemorrhage, no midline shift. CT face — non-displaced nasal bone fracture.

Procedure: Staple closure of scalp laceration at bedside. Admitted to neuro obs.

Cause: Assault by bodily force and by striking against or struck by other objects. Place: outside nightclub (commercial area / street).`,
  },
  {
    id: "burn-kitchen",
    title: "Kitchen burn – Right hand/forearm",
    text: `41-year-old female sustained burn injury while cooking at home in the kitchen. Hot oil splashed onto right hand and forearm when pot tipped over on stove.

Exam: Partial-thickness (2nd degree) burn involving dorsum of right hand and distal right forearm, approximately 3% TBSA. Blisters present. Intact sensation and capillary refill.

Procedure: Burn wound debridement at bedside and application of silver sulfadiazine dressing.

Mechanism: Contact with hot cooking oil. Place: kitchen of single-family home. Activity: cooking / food preparation.`,
  },
];
